import React, { useContext } from 'react';
import FileConstants from '../../../../FileConstants';
import { Row, Tabs, Modal, Button, Radio, Col, Checkbox } from 'antd';
import CollaborateQAContext from '../../ContextFiles/CollaborateQAContext';
import ProductQANavigation from './ProductQANavigation';
import DottedLoader from '../../DottedLoader';
import ProductCollaborateQAContainer from './ProductCollaborateQAContainer';
import ProductQAActionButtons from './ProductQAActionButtons';
import ProductModelInformation from './ProductModelInformation';
import ProductModelSizeInformation from './ProductModelSizeInformation';
import ModelReferenceInfo from '../ProductComponents/ModelReferenceInfo';
import ARViewTab from './ARViewTab';
import SubmitFeedbackModal from './SubmitFeedbackModal';
import RejectionModal from './RejectionModal';
import PaymentFailureModal from '../../PaymentFailureModal/PaymentFailureModal';
import InAppPurchaseLimitModal from '../InAppPurchaseLimitModal';
import ProductValidationState from './ProductValidationState';
import RejectionDetails from './RejectionDetails';
import RejectionDetailsModals from './RejectionDetailsModals';
import ProductQACanvasLoader from './ProductQACanvasLoader';
import QRCode from 'react-qr-code';
import ENVIRONMENT from '../../../../environments'
import ProductComparisonViewer from './ProductComparisonViewer';
import AddReferenceImages from './AddReferenceImages';
import ProductAssetSelectionModal from './ProductAssetSelectionModal';
import DeleteEntityModal from '../../DeleteEntityModal/DeleteEntityModal';
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import * as Utilities from '../../Utilities';


const { TabPane } = Tabs;


const ProductQAPageView = () => {
    const { access_level, productAssetData, collaborateMode, productData,
        setPaymentFailureModal, paymentFailureModal, productQAImages, dontShowAgain, closeTour1, closeTour2, changeTourVisibility,
        inAppLimitExceededModal, setInAppLimitExceededModal, initialLoader,
        updatePaymentDetailsOnFailure, paymentFailureMessage, projectID,
        deleteImageModal, deleteImageLoader, tourStep, setTourStep,
        selectedImageProductQA, cancelDeleteModal, deleteImage,
        totalFileSize, viewType, setViewType, changeAssetTab, selectedAsset, product_id, sentinelRef, successModal, setSuccessModal, actionType } = useContext(CollaborateQAContext);

    const disableBody = target => disableBodyScroll(target);
    const enableBody = target => enableBodyScroll(target);
    return (productAssetData && productData ? <>
        <ProductQANavigation />

        {(productData && productData.model_status == 4) ?
            <Row className='product-qa-tabpane-margin'>
                <Row className='justify-space-between w-100 product-qa-nav-header'>
                    <Col span={8} className='justify-in-start'>
                        <h1 className='manrope f-24 lh-32 w-500'>Review Your Model</h1>
                    </Col>
                    <Col span={8} className='justify-in-center'>
                        <Radio.Group value={viewType} onChange={(e) => {
                                setViewType(e.target.value)
                            }} buttonStyle='solid' className='radio-btn-settings'>
                            <Radio.Button className='manrope f-16 lh-22 w-600 radio-btn-style' value="comparison_view">1. Comparison</Radio.Button>
                            <Radio.Button className='manrope f-16 lh-22 w-600 radio-btn-style' value="feedback_view">2. Provide Feedback</Radio.Button>
                        </Radio.Group>
                    </Col>
                    <Col span={8} className='justify-in-end'>
                        <div className='product-qr-code-container'>
                            <div className='justify-space-between'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                    <path d="M10.6667 13.3333L16 16M10.6667 13.3333V18.6667L16 21.3333M10.6667 13.3333L16 10.6667L21.3333 13.3333M16 16L21.3333 13.3333M16 16V21.3333M16 21.3333L21.3333 18.6667V13.3333M12.5333 28C9.54667 28 8.05333 28 6.912 27.4187C5.90851 26.9073 5.09265 26.0915 4.58133 25.088C4 23.9467 4 22.4533 4 19.4667M28 19.4667C28 22.4533 28 23.9467 27.4187 25.088C26.9073 26.0915 26.0915 26.9073 25.088 27.4187C23.9467 28 22.4533 28 19.4667 28M19.4667 4C22.4533 4 23.9467 4 25.088 4.58133C26.0915 5.09265 26.9073 5.90851 27.4187 6.912C28 8.05333 28 9.54667 28 12.5333M12.5333 4C9.54667 4 8.05333 4 6.912 4.58133C5.90851 5.09265 5.09265 5.90851 4.58133 6.912C4 8.05333 4 9.54667 4 12.5333" stroke="black" stroke-opacity="0.85" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div className='manrope f-16 w-500 lh-24 black-085 ml-8 mr-16'>View in room</div>
                            </div>
                            <QRCode style={{ height: 46, width: 46 }} className="qr-code"
                                value={`d1rzyeqsmooian.cloudfront.net/ar-viewer/${product_id}?platform=${productAssetData.platform}&env=${ENVIRONMENT.ENV}`} />
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className='manrope f-14 w-500 lh-22 black-085 text-center'>
                            {viewType == 'comparison_view' ?
                                "Compare your model with the references and click 'Capture View' to provide feedback." :
                                "Select the images you want and use the toolbar to provide feedback."
                            }
                        </div>
                    </Col>
                </Row>
                
                    <Row className={`${viewType != 'feedback_view' ? `disp-none`: ``}`}>
                        <Col span={24} className={`product-qa-container`}>
                            <Row className={`product-qa-bg`}>
                                <ProductCollaborateQAContainer />
                            </Row>
                        </Col>
                    </Row> 
                    <ProductComparisonViewer />
                    <ProductQACanvasLoader />

            </Row>
            : ''}
        <div ref={sentinelRef} style={{ height: 1, opacity: 0 }} />
        <ProductValidationState />
        <RejectionDetails />
        <RejectionDetailsModals />
        <ProductModelInformation />
        {totalFileSize != 0 && <ProductModelSizeInformation />}
        <ModelReferenceInfo context_for={"collaborate_qa"} />
        {((["co-owner", "owner"].includes(access_level) || (projectID && access_level == "edit")) &&
            productData &&
            productData.model_status == 4) &&
            <ProductQAActionButtons />}
        <SubmitFeedbackModal />
        <RejectionModal />
        <AddReferenceImages/>
        <ProductAssetSelectionModal/>
        <PaymentFailureModal
            paymentFailureMessage={paymentFailureMessage}
            setPaymentFailureModal={setPaymentFailureModal}
            updatePaymentDetailsOnFailure={updatePaymentDetailsOnFailure}
            paymentFailureModal={paymentFailureModal}
        />
        <DeleteEntityModal
        onCancel={cancelDeleteModal}
        visible={deleteImageModal}
        deletingModelLoader={deleteImageLoader}
        selected_id={selectedImageProductQA}
        delete_model={deleteImage}
        heading={'Delete comparison image'}
        subText={'Are you sure you want to delete image?'}
        />

    
        <Tour
            steps={[
                {
                    selector: `[data_tut="reactour__tourStep2"]`,
                    content: () => (
                        <div>
                            <p className='manrope f-14 lh-22 w-500 black-085 mb-16'>
                                Compare your model with references as needed, then click here to capture a comparison image and add feedback.</p>
                            <div className='justify-space-between'>
                                <Checkbox
                                    checked={dontShowAgain}
                                     className="black-checkbox manrope f-14 w-400 black-00"
                                    onChange={changeTourVisibility}
                                >
                                    Don't show again
                                </Checkbox>

                                <Button
                                    className="modal-okay square font-14"
                                    onClick={closeTour2}>
                                    OK
                                </Button>
                            </div>
                        </div>
                    ),
                    style: { minWidth: 400 }
                }
            ]}
            isOpen={tourStep == 2}
            className="helper"
            rounded={5}
            accentColor={"#D93025"}
            onAfterOpen={() => {
                disableBody();
               
            }}
            onBeforeClose={enableBody}
            maskClassName="custom-mask"
            disableDotsNavigation={true}
            closeWithMask={false}
            lastStepNextButton={<span></span>}
            nextButton={<span></span>}
            prevButton={<span></span>}
            scrollSmooth={false}
            showCloseButton={false}
            showNavigation={false}
            showNavigationNumber={false}
            showNumber={false}
            onRequestClose={() => setTourStep(-2)}
        />

        <InAppPurchaseLimitModal visible={inAppLimitExceededModal} setVisible={setInAppLimitExceededModal} />
        <Modal
            className="image-share-success"
            width={620}
            visible={successModal}
            closable={false}
            footer={false}
            centered={true}
        >
            <div style={{ padding: "30px 0px 0 0px", textAlign: "center", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src='/img/success.png' style={{ width: "60px", height: "60px", marginBottom: "15px" }} alt="Alert" />
                <div style={{ marginBottom: "35px" }}>
                    <h3 className="success-modal-text" style={{ fontSize: 28, fontWeight: 500, color: '#555555' }}>Model {actionType == 'approve' ? 'approved' : 'rejected'} successfully!</h3>
                </div>
                <div className='justify-in-between' style={{ width: `${actionType == 'approve' ? '100%' : '57%'}` }}>
                    {actionType == 'approve' ? <Button key="back" style={{ textAlign: "center" }} className='basic-blue-btn f-14' onClick={() => window.location.href = '/products/' + product_id}>
                        Go to approved model's page
                    </Button> : ''}
                    <Button key="back" style={{ textAlign: "center" }} className='basic-blue-btn f-14' onClick={() => window.location.href = '/'}>
                        Go to Home Page
                    </Button>
                    <Button key="back" style={{ textAlign: "center" }} className='basic-blue-btn f-14' onClick={() => window.location.href = '/active-models?tab=in-review&origin=/home'}>
                        Go to Review section
                    </Button>
                </div>
            </div>
        </Modal>
    </> : <DottedLoader />)

}

export default ProductQAPageView;